var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-tree-panel',{attrs:{"data":_vm.departData},on:{"selected":_vm.onSelect}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }